/**
 * Office 模板文案与 sys_print_type 判断（无 API 依赖）。
 * @param {string} templateSuffix 已翻译后缀，调用方传 this.$t('模板')
 */
export function officeFileTemplateTypes(templateSuffix) {
  return ['Excel' + templateSuffix, 'Office' + templateSuffix];
}

export function isOfficeFileTemplateType(sysPrintType, templateSuffix) {
  return officeFileTemplateTypes(templateSuffix).includes(sysPrintType);
}

export function newOfficeFileTemplateType(templateSuffix) {
  return 'Office' + templateSuffix;
}

export function officeFileTemplateLabel(templateSuffix) {
  return 'Office' + templateSuffix;
}
